import { useCallback } from "react";
import { MainTable } from "components/MainTable";
import { IMainTableColumn } from "components/MainTable/MainTableInterfaces";
import { IActionPlan } from "entities/RCA/ActionPlanEntity/ActionPlanEntityInterfaces";
import { useNavigate } from "react-router-dom";
import { CORPORATE_BACKOFFICE_PATHS } from "constants/constants";
import { useActionPlansEditionContext } from "../../context/ActionPlansEditionContext";
import { useRCAMainStyles } from "pages/Corporate/RCA/RCA.styles";
import { ActionPlanParentType } from "../../ActionPlansTableInterfaces";

interface IActionPlansMainTableProps {
    columns: IMainTableColumn[];
    rows: IActionPlan[];
    loading: boolean;
    parentType: ActionPlanParentType;
    parentId: number;
}

const ActionPlansMainTable = ({
    columns,
    rows,
    loading,
    parentType,
    parentId,
}: IActionPlansMainTableProps) => {
    const mainClasses = useRCAMainStyles();
    const navigate = useNavigate();
    const { edit } = useActionPlansEditionContext();

    const handleRowClick = useCallback(
        (row: { action_plan_id?: number }) => {
            if (edit.length > 0) {
                return;
            }

            navigate(
                `/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.RCA.ROOT}/${CORPORATE_BACKOFFICE_PATHS.RCA.RCA_ACTION_PLANS.ROOT}/${row.action_plan_id}`,
                {
                    state: {
                        from: `/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.RCA.ROOT}/${
                            parentType === "rca"
                                ? CORPORATE_BACKOFFICE_PATHS.RCA.RCA_LIBRARY.ROOT
                                : CORPORATE_BACKOFFICE_PATHS.RCA.ISSUES.ROOT
                        }/${parentId}`,
                    },
                },
            );
        },
        [edit.length, navigate, parentType, parentId],
    );

    return (
        <MainTable
            maxHeight={false}
            customStyle={`${mainClasses.contentTable}`}
            paperElevation={0}
            paperCustomStyle={mainClasses.contentTablePaper}
            columns={columns}
            tableCellCustomStyle={undefined}
            rows={rows}
            loading={loading}
            onRowClick={handleRowClick}
        />
    );
};

export default ActionPlansMainTable;

